export default __webpack_public_path__ + "static/media/one.6665ffb9.svg";